import React from 'react';
interface PageTransitionProps {
  children: React.ReactNode;
}
export function PageTransition({
  children
}: PageTransitionProps) {
  return <div className="w-full animate-fade-in-up" data-id="element-176" data-mp="i2nhzt7y5phw">{children}</div>;
}